import PropTypes from 'prop-types';
import React, {Component} from 'react';

//helpers
import {rem} from 'utils/dom-utils';

//components
import FadingOverflow from 'components/FadingOverflow';

//styles
import {FixedFontSize, StyledResponsiveFontSize} from './styles';

class StepContentBase extends Component {
  static defaultProps = {
    isCompact: false,
    isResponsive: false,
    isScrollable: false
  };

  static propTypes = {
    device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
    fadeColor: PropTypes.string,
    isCompact: PropTypes.bool,
    isResponsive: PropTypes.bool,
    isScrollable: PropTypes.bool,
    noPadding: PropTypes.bool
  };

  render() {
    const {children, dangerouslySetInnerHTML, device, isCompact, isResponsive, noPadding, footer, ...forwardedProps} =
      this.props;

    return (
      <FadingOverflow {...forwardedProps}>
        <div style={{flexGrow: 1}}>
          {isResponsive ? (
            <StyledResponsiveFontSize
              baseWidth={380}
              children={children}
              dangerouslySetInnerHTML={dangerouslySetInnerHTML}
              isCompact={isCompact}
              minFontSize={rem(1)}
              minPadding={noPadding ? 0 : rem(device === 'desktop' ? 2 : 1.5)}
            />
          ) : (
            <FixedFontSize
              children={children}
              dangerouslySetInnerHTML={dangerouslySetInnerHTML}
              device={device}
              isCompact={isCompact}
            />
          )}
        </div>
        {footer}
      </FadingOverflow>
    );
  }
}

export const StepContentDesktop = props => <StepContentBase data-cy="step-content" device="desktop" {...props} />;

export const StepContentMobile = props => <StepContentBase data-cy="step-content" device="mobile" {...props} />;
